
import axios from 'axios'
import { host } from './base.api.js'

/**
 * 活动相关接口地址
 */
const urls = {
  /**
   * 获取活动QA预览内容
   */
  QAPreviewContent: host + '/api/socialagent/activity/getquestionandanswers'
}

export default {
  /**
   * 获取活动QA预览内容
   * @param {Number} platformActivityId 活动Id
   */
  getQAPreviewContent (platformActivityId) {
    return axios.get(urls.QAPreviewContent + '?' + `platformActivityId=${platformActivityId}&t=${new Date().getTime()}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/qaModule.js